import React, { useEffect, useState } from 'react';
import { GetViewType } from "../../../utils/view-type";
import { useTranslation } from "react-i18next";
import Sort from "../../sort/sort";
import Search from "../../search/search";
import { DeleteIcon, FormIcon, FormIconPure, MailIcon, RedCloseIcon } from "../../../icons/icons";
import Filter from "../../filter/filter";
import DropDown from "../../../assets/dropDown/dropDown";
import Pagination from "../../pagination/pagination";
import CustomCheckBox from "../../UI/customCheckBox/customCheckBox";
import { Link, useNavigate } from "react-router-dom";
import CustomInput from "../../UI/customInput/customInput";
import CustomButton from "../../UI/customButton/customButton";
import { useSelector } from "react-redux";
import { Get, Post } from "../../../apis/api";
import LoadingFix from "../../loading-fix/loading-fix";
import moment from "moment-jalaali";
import { CONST } from "../../../utils/CONST";
import { toggleAuth } from "../../../store/user/user.reducer";
import { setPermissions } from "../../../store/permissions/permissions.reducer";
import { toast } from "react-toastify";
import FormNumberThree from "../../../pages/visa-orders/forms/formNumberThree";
import html2pdf from "html2pdf.js";
import { Row } from './components/Row.tsx';
import clsx from 'clsx'
import { MobileRow } from './components/MobileRow/MobileRow.tsx'
import { VISA_PAGES_FILTER, createStatusParam } from '../../../utils/visaPagesFilter.ts'

export const NewCurrentVisaTable = () => {
  const viewType = GetViewType()
  const { t } = useTranslation();
  const user = useSelector((state) => state.user.user)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [nationality, setNationality] = useState([])
  const [perPage, setPerPage] = useState(10)
  const [form, setForm] = useState({})
  const [pdf, setPdf] = useState('')
  const [id, setId] = useState(null)
  const lng = useSelector((state) => state.common.lng)
  const isAgent = user?.role_key === "agent"

  const [searchTime, setSearchTime] = useState("")
  useEffect(() => {
    handleList()
  }, [])

  const navigate = useNavigate()

  const handleList = (page, per_page, search = "") => {
    setLoading(true)

    Get(`${isAgent ? 'agent' : 'admin'}/visas?page=${page || 1}&per_page=${per_page || 10}&q=&${search}${createStatusParam('CURRENT_VISAS', isAgent ? 'AGENT' : 'SUPER_ADMIN')}`).then((res) => {
      setData(res?.details.data)
      setNationality(res?.details.nationality        )
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleForm = ({ name, value }) => {
    setForm((prevState) => ({ ...prevState, [name]: value }));
  };

  useEffect(() => {
    if (pdf) {
      handleSubmit(id)
    }
  }, [pdf])

  const handleSubmit = async (id) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("form", "otb_from");
    formData.append("subject", "OK TO BOARD");
    formData.append("otb_file", pdf, 'my-document.pdf');
    formData.append("automation_number", form[id]?.value)
    formData.append("email_body", "OK TO BOARD")

    Post(`/admin/visas/send-otb/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((res) => {
        toast.success(res.msg);
        setId(null);
        navigate("/")
      })
      .catch((error) => {
        toast.error(error.data.message || error.data.msg);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleStatus = (status) => {
    let find = CONST.status.find((item) => {
      return item.id === status
    })
    return (
      <div className={`rounded-lg text-center py-2 text-green-200 bg-green-100 text-[8px] md:text-xs w-full md:w-[86px]`}>
        {find?.[`${lng}`]}
      </div>
    )
  }

  const handleSearch = (e) => {

    clearTimeout(searchTime)


    let loop = setTimeout(() => {

      handleList(1, perPage, e);

    }, 1000)
    setSearchTime(loop)

  }

  return (
    <div className={""}>
      {
        loading && <LoadingFix />
      }
      <div className={"w-full flex justify-between mt-7"}>
        <span className={"text-primary-400"}>{t("currentVisas")}</span>
      </div>
      {
        viewType === "WEB" ?
          <div
            className="relative overflow-x-auto w-full  bg-white rounded-lg flex flex-col gap-4  items-stretch !mt-5 border border-1 border-gray-200 overflow-hidden pb-4">
            <div className={clsx(' grid  gap-2 w-full p-4 text-sm text-gray-800 uppercase text-center', isAgent ? 'grid-cols-7' : 'grid-cols-8')}>
              <span className='col-span-1'>{t("applicationNumber")}</span>
              <span className='col-span-1'>{t("visaType")}</span>
              {!isAgent && <span className='col-span-1'> {t("agent")}</span>}
              <span className='col-span-1'>{t("requestDate")}</span>
              <span className='col-span-1'>{t("status")}</span>
              <span className='col-span-3'>{t("CommandLetterNumber")} / {t("automationNumber")}</span>
              {/* <span className='col-span-1'>{t("automationNumber")}</span> */}

            </div>

            <div className='bg-gray-100 w-full h-[1px]'></div>

            {data?.data?.map(item => <Row onSuccessMutate={handleList} nationality={nationality} {...item} key={item.id} />)}
            {data?.data?.length == 0 && <span className='text-center py- text-gray-700 text-sm'>{t('ThereIsNoVisa')}</span>}

          </div>
          :
          <div className={"flex flex-col gap-4 mt-3"}>
            {/* <div className={"bg-white p-3 rounded-lg flex gap-5"}>
              <Filter />
              <div className={"w-full"}>
                <Search onChange={handleSearch} />
              </div>
            </div> */}
            {
              data?.data?.map((item, index) => {

                return <MobileRow nationality={nationality}  {...item} />

                // return (
                //   <div className={"flex p-4 rounded-lg bg-white"}>
                //     <div className={"flex w-full"}>
                //       <div className={"mx-1 min-w-7"}>{item?.id}</div>
                //       <div className={"flex w-full flex-wrap gap-y-8 justify-between"}>
                //         <div className={"flex w-full justify-between"}>
                //           {/*<div className={"flex w-1/2 flex-col"}>*/}
                //           {/*  {item?.crew?.nationality}*/}

                //           {/*</div>*/}
                //           <div className={"flex w-1/2 justify-end text-end text-sm"}>{item?.visa?.[`${lng}_name`]}</div>
                //         </div>
                //         <div className={"flex w-full justify-between items-center"}>
                //           <div className={"flex w-1/4 text-sm text-gray-900 text-center justify-end ml-1"}>
                //             {handleStatus(item?.visa?.status)}
                //           </div>
                //           <div className={"flex w-1/3 text-sm text-gray-900 justify-center text-center"}> {(item?.agent?.name ?? '-') + " " + (item?.agent?.last_name ?? '-')}</div>
                //           <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                //             <div onClick={() => navigate(`/visa-orders/forms/${item?.visa?.id}`)}>
                //               {!(item?.visa?.status === 0 || item?.visa?.status === 1) ? <FormIconPure /> : <FormIcon />}
                //             </div>
                //           </td>
                //           <td className="px-6 py-4 text-center">
                //             {
                //               user?.role_key === "agent" ?
                //                 <div className={"text-gray-500 text-sm mt-1"}>
                //                   <div className={"flex gap-2 justify-center"}>
                //                     <span>{"1245464564564"}</span>
                //                   </div>
                //                 </div>
                //                 :
                //                 <div className={"text-gray-500 text-sm mt-1"}>
                //                   <div className={"flex gap-2 justify-center"}>
                //                     <span className={"w-[120px]"}>
                //                       <CustomInput
                //                         placeHolder={t("automationNumber")}
                //                         label={t("automationNumber")}
                //                         name={"automationNumber" + item.id}
                //                         onchange={(e) => handleForm(item.id, e)}
                //                       />
                //                     </span>
                //                     <div className={"w-[80px]"}>
                //                       <CustomButton styles={"text-sm"} title={t("save")} />
                //                     </div>
                //                   </div>
                //                 </div>
                //             }
                //           </td>
                //         </div>
                //       </div>
                //     </div>
                //   </div>
                // )
              })
            }

            {data?.data?.length == 0 && <span className='text-center py- text-gray-700 text-sm'>{t('ThereIsNoVisa')}</span>}
          </div>
      }
      <div className={'flex flex-col  md:flex-row md:items-center md:justify-between mt-4'}>
        <DropDown onChange={(per_page) => {
          handleList(1, per_page)
          setPerPage(per_page)
        }} />
        <Pagination itemsPerPage={data?.per_page} total={data?.total} last_page={data?.last_page} changePage={(page) => handleList(page, perPage)} />
      </div>
    </div>
  );
};



// const OldTable = <table className="w-full text-sm text-gray-500">
//   <thead className="text-xs text-gray-700 uppercase ">
//     <tr className={"border-b border-gray-400"}>
//       <th scope="col" className="px-6 py-3 text-center w-4 font-normal text-gray-600 text-sm">
//         <div className={"mt-1"}>
//           {t("applicationNumber")}
//         </div>
//       </th>

//       {/*<th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">*/}
//       {/*  <div className={"mt-1 justify-center flex"}>*/}
//       {/*    {t("nation")}*/}
//       {/*  </div>*/}
//       {/*</th>*/}
//       <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
//         <div className={"mt-1 flex  justify-center"}>
//           {t("visaType")}
//         </div>
//       </th>
//       <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
//         <div className={"mt-1 flex  justify-center"}>
//           {t("requestDate")}
//         </div>
//       </th>
//       <th scope="col" className=" py-3 mx-auto text-center font-normal text-gray-600 text-sm">
//         <div className={"mt-1 flex justify-center"}>
//           {t("status")}
//         </div>
//       </th>
//       <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
//         <div className={"mt-1 flex  justify-center"}>
//           {t("agent")}
//         </div>
//       </th>

//       <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
//         <div className={"mt-1 flex  justify-center"}>
//           {t("forms")}
//         </div>
//       </th>

//       <th scope="col" className=" py-3  text-center font-normal text-gray-600 text-sm">
//         <div className={"mt-1 flex  justify-center"}>
//           {t("automationNumber")}
//         </div>
//       </th>

//     </tr>
//   </thead>
//   <tbody>
//     {data?.data?.map((item, index) => (
//       <Row {...item} />
//       // <>
//       //   {
//       //     id === item.id &&
//       //     <FormNumberThree id={item.id} onPdf={(e) =>  setPdf(e)}/>
//       //   }
//       //   <tr key={index} className="bg-white border-b border-gray-400">

//       //     <td className="px-6 py-4 text-center">
//       //       <div className={"text-gray-500 text-sm mt-1"}>
//       //         {item?.id}
//       //       </div>
//       //     </td>
//       //     {/*<td className="px-6 py-4 text-center">*/}
//       //     {/*  <div className={"text-gray-500 text-sm mt-1"}>*/}
//       //     {/*    {item?.crew?.nationality}*/}
//       //     {/*  </div>*/}
//       //     {/*</td>*/}
//       //     <td className="px-6 py-4 text-center">
//       //       <div className={"text-gray-500 text-sm mt-1"}>
//       //         {item?.visa?.[`${lng}_name`]}
//       //       </div>
//       //     </td>
//       //     <td className="px-6 py-4 text-center">
//       //       <div className={"text-gray-500 text-sm mt-1"}>
//       //         {item?.visa?.created_at && moment(item.visa.created_at).format(lng === "en" ? "YYYY-MM-DD" : "jYYYY-jMM-jDD" )}
//       //       </div>
//       //     </td>

//       //     <td className=" py-4 text-start text-gray-500 text-sm font-medium">
//       //       <div className={"mt-1 flex justify-center"}>
//       //         {handleStatus(item?.status)}
//       //       </div>
//       //     </td>


//       //     <td className="px-6 py-4 text-center">
//       //       <div className={"text-gray-500 text-sm mt-1"}>
//       //         {(item?.agent?.name ?? '-') + " " + (item?.agent?.last_name ??'-')}
//       //       </div>
//       //     </td>
//       //     <td className=" py-4  text-start text-gray-500 text-sm font-medium">
//       //       {

//       //         <div className={"flex justify-center" }>
//       //           <div onClick={() => navigate(`/visa-orders/forms/${item?.visa?.id}`)}>
//       //             {!(item?.visa?.status === 0 || item?.visa?.status === 1) ? <FormIconPure/> : <FormIcon/>}
//       //           </div>
//       //         </div>
//       //       }

//       //     </td>
//       //     <td className="px-6 py-4 text-center">
//       //       {
//       //         user?.role_key === "agent" ?
//       //           <div className={"text-gray-500 text-sm mt-1"}>
//       //             <div className={"flex gap-2 justify-center"}>
//       //               <span>{"1245464564564"}</span>
//       //             </div>
//       //           </div>
//       //           :
//       //           <div className={"text-gray-500 text-sm mt-1"}>
//       //             <div className={"flex gap-2 justify-center"}>
//       //         <span className={"w-[120px]"}>
//       //           <CustomInput
//       //             placeHolder={t("automationNumber")}
//       //             label={t("automationNumber")}
//       //             name={"automationNumber" + item.id}
//       //             onchange={(e) => handleForm({name:item.id, value:e})}
//       //           />
//       //         </span>
//       //               <div className={"w-[80px]"}>
//       //                 <CustomButton onClick={() => {
//       //                   setId(item.id)
//       //                 }}  styles={"text-sm"} title={t("save")}/>
//       //               </div>
//       //             </div>
//       //           </div>
//       //       }
//       //     </td>

//       //   </tr>
//       // </>


//     ))}
//   </tbody>
// </table>